import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox, CheckboxGroup } from '../../../components/ui/Checkbox';

const TechQuestionnaire = ({ 
  techTrack, 
  onTechTrackChange,
  primarySkills,
  onPrimarySkillsChange,
  architectureExperience,
  onArchitectureExperienceChange
}) => {
  const techTrackOptions = [
    { value: 'software', label: 'Software Engineering', description: 'Backend, frontend, full-stack development' },
    { value: 'data', label: 'Data & AI', description: 'Data engineering, ML, AI, analytics' },
    { value: 'product', label: 'Product Management', description: 'Product strategy, roadmap, user experience' },
    { value: 'devops', label: 'DevOps & Infrastructure', description: 'Cloud, CI/CD, platform engineering' }
  ];

  const softwareSkills = [
    { id: 'backend', label: 'Backend Development' },
    { id: 'frontend', label: 'Frontend Development' },
    { id: 'fullstack', label: 'Full-Stack Development' },
    { id: 'mobile', label: 'Mobile Development' },
    { id: 'api', label: 'API Design & Development' },
    { id: 'microservices', label: 'Microservices Architecture' }
  ];

  const dataSkills = [
    { id: 'data-engineering', label: 'Data Engineering' },
    { id: 'ml', label: 'Machine Learning' },
    { id: 'ai', label: 'Artificial Intelligence' },
    { id: 'analytics', label: 'Data Analytics' },
    { id: 'big-data', label: 'Big Data Technologies' },
    { id: 'data-science', label: 'Data Science' }
  ];

  const productSkills = [
    { id: 'strategy', label: 'Product Strategy' },
    { id: 'roadmap', label: 'Roadmap Planning' },
    { id: 'user-research', label: 'User Research' },
    { id: 'analytics', label: 'Product Analytics' },
    { id: 'agile', label: 'Agile Methodologies' },
    { id: 'stakeholder', label: 'Stakeholder Management' }
  ];

  const devopsSkills = [
    { id: 'cloud', label: 'Cloud Infrastructure (AWS/Azure/GCP)' },
    { id: 'cicd', label: 'CI/CD Pipelines' },
    { id: 'kubernetes', label: 'Kubernetes & Containerization' },
    { id: 'monitoring', label: 'Monitoring & Observability' },
    { id: 'security', label: 'Security & Compliance' },
    { id: 'automation', label: 'Infrastructure Automation' }
  ];

  const architectureOptions = [
    { value: 'none', label: 'No architecture experience' },
    { value: 'component', label: 'Component/Module level' },
    { value: 'application', label: 'Application level' },
    { value: 'system', label: 'System/Platform level' },
    { value: 'enterprise', label: 'Enterprise architecture' }
  ];

  const getSkillsForTrack = () => {
    switch (techTrack) {
      case 'software': return softwareSkills;
      case 'data': return dataSkills;
      case 'product': return productSkills;
      case 'devops': return devopsSkills;
      default: return [];
    }
  };

  const handleSkillToggle = (skillId) => {
    const newSkills = primarySkills?.includes(skillId)
      ? primarySkills?.filter(s => s !== skillId)
      : [...primarySkills, skillId];
    onPrimarySkillsChange(newSkills);
  };

  return (
    <div className="w-full">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Technology Specialization
      </h2>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-6 md:mb-8">
        Help us understand your technical expertise and focus areas
      </p>
      <div className="space-y-6">
        <Select
          label="Primary Tech Track"
          description="Select your main area of expertise"
          options={techTrackOptions}
          value={techTrack}
          onChange={onTechTrackChange}
          required
        />

        {techTrack && (
          <>
            <CheckboxGroup label="Primary Skills & Expertise">
              {getSkillsForTrack()?.map((skill) => (
                <Checkbox
                  key={skill?.id}
                  label={skill?.label}
                  checked={primarySkills?.includes(skill?.id)}
                  onChange={() => handleSkillToggle(skill?.id)}
                />
              ))}
            </CheckboxGroup>

            <Select
              label="Architecture Experience"
              description="Your experience with system design and architecture"
              options={architectureOptions}
              value={architectureExperience}
              onChange={onArchitectureExperienceChange}
              required
            />
          </>
        )}

        <div className="p-4 md:p-6 rounded-xl bg-muted">
          <p className="text-sm md:text-base text-muted-foreground">
            <strong className="text-foreground">Privacy Note:</strong> Your specific technology stack and tools will remain anonymous. We focus on your expertise level and problem-solving capabilities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TechQuestionnaire;